import { ApiService } from '../services/api/ApiService';
import { MapLogic } from './map';

export class Logic {
    private _apiService?: ApiService;
    private _mapLogic?: MapLogic;

    apiService() {
        if (!this._apiService) {
            this._apiService = new ApiService();
        }
        return this._apiService;
    }

    map() {
        if (!this._mapLogic) {
            this._mapLogic = new MapLogic(this);
        }
        return this._mapLogic;
    }
}
